export default class UserExperience {
    constructor({ byChannelId, defaultChannel }) {
        this._defaultChannel = defaultChannel;
        this._userExperienceByRegion = {
            AMER: {
                schedule: byChannelId.us,
            },
            EUR: {
                schedule: byChannelId.europe,
            },
            UK: {
                schedule: byChannelId.europe,
            },
            APAC: {
                schedule: byChannelId.asia,
            },
            MIDEAST: {
                schedule: byChannelId.europe,
            },
            AFRICA: {
                schedule: byChannelId.europe,
            },
            CANADA: {
                schedule: byChannelId.us,
            },
            AUSTRALIA: {
                schedule: byChannelId.australia,
            },
        };
    }

    getLiveChannelIdFromRegion(region) {
        const regionInfo = this._getRegionInfo(region);
        const schedule = regionInfo && regionInfo.schedule;
        return (
            (schedule && schedule.channelId) || this._defaultChannel.channelId
        );
    }

    getLiveAPIIdFromRegion(region) {
        const regionInfo = this._getRegionInfo(region);
        const schedule = regionInfo && regionInfo.schedule;
        return (schedule && schedule.apiId) || this._defaultChannel.apiId;
    }

    _getRegionInfo(region) {
        return this._userExperienceByRegion[region && region.toUpperCase()];
    }
}
